import React from 'react';


//THIS HERE IS THE SOLUTION TO THE BAR'S ON CLICK!!!
//When adding on click to bars react takes that in the literal sense, it literally will only click on the bar
const CustomBarShape = (props) => {
  const {
    x,
    y,
    width,
    height,
    fill,
    chartHeight, 
    payload,
    onBarClick,
  } = props;

  return (
    <g>
      <rect x={x} y={y} width={width} height={height} fill={fill} />
      <rect
        x={x}
        y={0}  
        width={width}
        height={chartHeight}
        fill="transparent"
        style={{ cursor: 'pointer' }}
        onClick={() => onBarClick(payload)}
      />
    </g>
  );
};

export default CustomBarShape;
